import { render, staticRenderFns } from "./DbSyncLogs.vue?vue&type=template&id=eb8c9c7c&"
import script from "./DbSyncLogs.vue?vue&type=script&lang=ts&"
export * from "./DbSyncLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports